import { Button, Checkbox, Stack, Typography } from "@mui/material";
import { ChangeEvent, useCallback } from "react";
import { IntakeQuestion } from "src/api/types";
import { theme } from "src/assets/theme";
import { useSelection } from "src/context/ItemsSelectionProvider/useSelection";

interface Props {
  count: number;
  handleOpen: () => void;
  handleOpenRemove: () => void;
  questions: IntakeQuestion[];
}

const Actions = ({ count, handleOpen, questions, handleOpenRemove }: Props) => {
  const { selected, setSelected } = useSelection();

  const handleSelectAll = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      if (e.target.checked) {
        setSelected(questions.map((q) => q.id));
      } else {
        setSelected([]);
      }
    },
    [setSelected, questions],
  );

  return (
    <Stack
      width="100%"
      height={60}
      direction="row"
      bgcolor={theme.palette.teal[100]}
      justifyContent="space-between"
      alignItems="center"
      padding={"0 16px"}
    >
      <Stack direction={"row"} alignItems="center" gap={2}>
        <Checkbox
          color="primary"
          aria-label="select all rooms"
          onChange={handleSelectAll}
          checked={selected.length > 0 && questions.length === selected.length}
          indeterminate={
            selected.length > 0 && selected.length < questions.length
          }
        />
        <Typography>Selected: {count}</Typography>
      </Stack>
      <Stack direction={"row"} gap={2}>
        <Button size="small" variant="secondary" onClick={handleOpen}>
          Copy
        </Button>
        <Button color="error" onClick={handleOpenRemove}>
          Remove
        </Button>
      </Stack>
    </Stack>
  );
};

export default Actions;
